import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();

$(document).ready(function(){


	$("[name='rekening']").on("valid.zf.abide", function(ev,el) {
		$('#deeltwee').removeClass('donotshow');
		$('#deeleen').addClass('donotshow');
    });

	$('#naarbetaling').prop("disabled",checkstatus());
	
	$("#voornaamdonateur").on("valid.zf.abide", function(ev,el) {
			$('#voornaamdonateur').attr("test", "valid");
	  		$('#naarbetaling').prop("disabled",checkstatus());
	});	
	$("#familienaamdonateur").on("valid.zf.abide", function(ev,el) {
			$('#familienaamdonateur').attr("test", "valid");
	  		$('#naarbetaling').prop("disabled",checkstatus());
	});	
	$("#email").on("valid.zf.abide", function(ev,el) {
			$('#email').attr("test", "valid");
	  		$('#naarbetaling').prop("disabled",checkstatus());
	});
	$("#bedrag").on("valid.zf.abide", function(ev,el) {
			$('#bedrag').attr("test", "valid");
	  		$('#naarbetaling').prop("disabled",checkstatus());
	});

	function checkstatus() {
		let voornaamdonateur = $('#voornaamdonateur').attr("test"); 
		let familienaamdonateur = $('#familienaamdonateur').attr("test"); 
		let email = $('#email').attr("test");  
		let bedrag = $('#bedrag').attr("test"); 
		if ((voornaamdonateur == "valid") && 
			(familienaamdonateur == "valid") && 
			(email == "valid") && 
			(bedrag == "valid") ) {
			return false;
		} else {
			return true;
		}
	}
})